import { Divergent } from "@/components/exams/exams-tab/exam-arbitration";
import { Documents, Interpretations, Reports } from "@/components/exams/exams-tab/exam-list";
import { PivotTable } from "@/components/exams/exams-tab/exam-pivot-view";
import { ExamUpload } from "@/components/exams/exams-tab/exam-upload";
import { useExamsByPatient } from "@/hooks/use-exams";

export function ExamsTab({ patientId }: { patientId: number }) {
	const { data } = useExamsByPatient(patientId);

	if (data.documents.length === 0) {
		return (
			<div className="flex flex-col gap-3">
				<ExamUpload patientId={patientId} />

				<p className="text-sm text-muted-foreground">Nenhum exame registrado.</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-6">
			<ExamUpload patientId={patientId} />

			<PivotTable pivot={data.pivot} />

			<Divergent cells={data.divergent} />

			<Reports reports={data.reports} />

			<Interpretations items={data.interpretations} />

			<Documents documents={data.documents} />
		</div>
	);
}
